import * as types from "../mutation-types";
import axios from "axios";

export const state = {
  trades: null
};

export const actions = {
  async fetchTradeDetails({ commit }, data) {
    try {
      const { response } = await axios.get(
        "/api/v1/tradedetails?id=" + data.tradeId
      );

      commit(types.FETCH_TRADE_DETAILS_SUCCESS, { details: response });
    } catch (e) {
      commit(types.FETCH_TRADE_DETAILS_FAILURE);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/dashboard.js